import { useState } from "react";
import { Settings2, X, Sparkles } from "lucide-react";
import { NewRequestDialog } from "../NewRequestDialog";
import { useAssistant } from "./AssistantContext";
import { AssistantBar, IconBtn } from "./AssistantPanel";
import { AssistantSettings } from "./AssistantSettings";
import { AssistantOnboarding } from "./AssistantOnboarding";

function FloatingAssistant() {
  const a = useAssistant();
  const [cfgOpen, setCfgOpen] = useState(false);
  if (a.form) return null;
  if (!a.aiOn) return (
    <button onClick={() => a.setAiEnabled(true)} data-testid="assistant-enable-fab" title="Ativar a Assistente de IA"
      className="fixed bottom-4 right-4 z-40 no-print flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/90 px-3 py-1.5 text-[11px] font-semibold text-slate-600 shadow-sm backdrop-blur transition-colors hover:border-sky-300 hover:text-sky-700">
      <Sparkles className="h-3.5 w-3.5" />Ativar IA</button>);
  return (
    <div className="fixed bottom-3 right-3 z-40 no-print flex w-[min(calc(100vw-1.5rem),440px)] flex-col items-stretch gap-2" data-testid="assistant-floating">
      {cfgOpen && (
        <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-xl" data-testid="assistant-settings-popover">
          <div className="mb-1 flex justify-end"><button className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" onClick={() => setCfgOpen(false)} title="Fechar" data-testid="assistant-settings-close"><X className="h-4 w-4" /></button></div>
          <AssistantSettings />
        </div>)}
      <AssistantBar extra={<IconBtn title="Configurar assistente" active={cfgOpen} onClick={() => setCfgOpen(!cfgOpen)} testid="assistant-settings-toggle"><Settings2 className="h-4 w-4" /></IconBtn>} />
    </div>);
}

// Everything the assistant needs on top of the portal: compact bar, first access and the form it opens.
export function AssistantMount() {
  const a = useAssistant();
  if (!a) return null;
  return <>
    <FloatingAssistant />
    <AssistantOnboarding />
    <NewRequestDialog open={!!a.formType} type={a.formType} draftId={a.formDraft} onOpenChange={(o) => !o && a.setFormType(null)} />
  </>;
}
